/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfAutocompleteItemDto } from '../../models/paginated-dto-of-autocomplete-item-dto';

export interface Autocomplete$Params {
  query: string;
}

export function autocomplete(http: HttpClient, rootUrl: string, params: Autocomplete$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfAutocompleteItemDto>> {
  const rb = new RequestBuilder(rootUrl, autocomplete.PATH, 'get');
  if (params) {
    rb.path('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfAutocompleteItemDto>;
    })
  );
}

autocomplete.PATH = '/api/v1/autocomplete/{query}';
